import api from '@/services/Api'

export default{
  connection (identifiants) {
    return api().post('connection', identifiants)
  },

  register (identifiants) {
    return api().post('createaccount', identifiants)
  },

  changePassword (identifiants) {
    return api().post('changepassword', identifiants)
  }
}
